import * as React from "react";

type CommunityAvatarProps = {
  src?: string | null;
  name?: string | null;
  className?: string;
};

/** Keep the local initial visible until a remote avatar has actually loaded. */
export function CommunityAvatar({ src, name, className = "" }: CommunityAvatarProps) {
  const normalizedSrc = src?.trim() || "";
  // A different URL starts a fresh load, including when returning to an earlier URL.
  return <AvatarImage key={normalizedSrc} src={normalizedSrc} name={name} className={className} />;
}

function AvatarImage({ src, name, className }: CommunityAvatarProps) {
  const [status, setStatus] = React.useState<"loading" | "loaded" | "error">("loading");
  const initial = Array.from(name?.trim() || "?")[0];

  return (
    <span
      aria-hidden="true"
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-200 text-gray-500 ${className}`}
    >
      <span className={status === "loaded" ? "invisible" : undefined}>{initial}</span>
      {src && status !== "error" ? (
        <img
          src={src}
          alt=""
          className={`absolute inset-0 h-full w-full object-cover ${status === "loaded" ? "" : "invisible"}`}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
        />
      ) : null}
    </span>
  );
}
